(function () {
  'use strict';

  const ROOT = '.brand-best-sellers-hero';
  const HIDDEN_CLASS = 'brand-best-sellers-hero__filter-hidden';
  const TITLE_MATCH = /^product category$/i;
  const DATA_KEYS = ['product_type', 'category', 'product-category', 'product_category', 'productcategory'];
  const BLOCK_SELECTOR = '.gf-option-block, .gf-filter-item, .gf-option, [class*="gf-option-"]';
  const TITLE_SELECTOR = '.gf-block-title, .gf-option-title, .gf-label, .gf-filter-heading, .facet-filters__label, summary, strong, h3, h4';

  function isBestSellersPage() {
    return Boolean(document.querySelector(ROOT));
  }

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function hideBlock(block) {
    if (!block || block.classList.contains(HIDDEN_CLASS)) return;
    block.classList.add(HIDDEN_CLASS);
    block.setAttribute('hidden', '');
    block.setAttribute('aria-hidden', 'true');
  }

  function hideByDataKeys(scope) {
    DATA_KEYS.forEach(function (key) {
      scope.querySelectorAll(
        '[data-filter-key="' + key + '"], [data-key="' + key + '"], [data-handle="' + key + '"], [data-filter="' + key + '"]'
      ).forEach(function (node) {
        hideBlock(node.closest(BLOCK_SELECTOR) || node);
      });
    });
  }

  function hideByTitle(scope) {
    scope.querySelectorAll(BLOCK_SELECTOR).forEach(function (block) {
      const titleNode = block.querySelector(TITLE_SELECTOR);
      if (titleNode && TITLE_MATCH.test(normalizeText(titleNode.textContent))) {
        hideBlock(block);
      }
    });
  }

  function hideNativeCategoryMenu(scope) {
    scope.querySelectorAll('.coll-filter-menu > strong').forEach(function (label) {
      if (TITLE_MATCH.test(normalizeText(label.textContent))) {
        hideBlock(label.closest('.coll-filter-menu'));
      }
    });
  }

  function hideProductCategoryFilter() {
    if (!isBestSellersPage()) return;

    const scopes = document.querySelectorAll('#gf-tree, #gf-filter-tree, .gf-left, [id*="gf-tree"], .spf-filter-sidebar');
    const targets = scopes.length ? scopes : [document];

    targets.forEach(function (scope) {
      hideByDataKeys(scope);
      hideByTitle(scope);
      hideNativeCategoryMenu(scope);
    });
  }

  function init() {
    hideProductCategoryFilter();

    document.addEventListener('globoFilterUpdate', hideProductCategoryFilter);
    document.addEventListener('globoFilterRenderCompleted', hideProductCategoryFilter);

    let attempts = 0;
    const interval = setInterval(function () {
      hideProductCategoryFilter();
      attempts += 1;
      if (attempts >= 20) clearInterval(interval);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
